import React, { useContext } from 'react'
import { Navigate } from 'react-router'

import { ROLES } from '../constants/roles'
import { PATHS } from '../constants/paths'
import { UserContext } from '../data/UserContext'
import { hasInternshipPermissions } from '../utils/hasInternshipPermissions'

const homepathMap = {
  [ROLES.CORPS_CHIEF]: PATHS.FACM_ALL,
  [ROLES.DUTY_OFFICER]: PATHS.FACM_ALL,
  [ROLES.MOUNTAIN_OFFICER]: PATHS.FACM_ALL,
  [ROLES.SUPER_ADMIN]: PATHS.USER_LIST,
  [ROLES.ADMIN]: PATHS.USER_LIST,
  [ROLES.INTERNSHIP_DIRECTOR]: PATHS.INTERNSHIP_LIST,
}

export const getHomepage = ({ user }) => {
  const homepath = homepathMap[user.role]
  if (homepath) {
    return homepath
  }

  if (hasInternshipPermissions({ user })) {
    return PATHS.INTERNSHIP_LIST
  }

  return PATHS.PROFILE
}

export const HomeRedirect = () => {
  const { user } = useContext(UserContext)

  return <Navigate to={getHomepage({ user })} />
}
